module.exports = __webpack_public_path__ + "img/dibu-wenzi-png.b36c1d16.svg";